import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Button } from '../ui/Button';
import { MobileNav } from './MobileNav';

const LOGO_URL =
  'https://pub-67931846c43548b18bfbc16e1101b0c6.r2.dev/client%20images%20uploads/bharat-consultancy/Final_logo_bharat_consultancy(1).jpg%20(1).jpeg';

const NAV_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/services', label: 'Services' },
  { to: '/about', label: 'About Us' },
  { to: '/contact', label: 'Contact' },
];

export function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { isAuthenticated } = useAuth();

  return (
    <header className="sticky top-0 z-40 border-b border-line bg-paper/95 backdrop-blur-sm">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-2 sm:px-6">
        {/*
          The logo file is a wide horizontal lockup (icon + "Bharat
          Consultancy" wordmark already built in) — NOT an icon-only
          mark. Forcing it into a small rounded-full square with
          object-cover was cropping out almost the entire wordmark,
          which is why it looked broken/missing. Rendering it at its
          natural aspect ratio (h-9, width auto) shows the whole logo,
          and the adjacent text span is removed since the logo image
          already contains the wordmark — keeping both would duplicate
          "Bharat Consultancy" twice.
        */}
        <Link to="/" className="flex items-center">
          <img src={LOGO_URL} alt="Bharat Consultancy" className="h-11 w-auto object-contain sm:h-14" />
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors ${isActive ? 'text-seal-blue' : 'text-ink/70 hover:text-ink'}`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        {/*
          Per the brief: admin access is intentionally NOT in the header
          at all — it lives only in the footer as "Admin Login" — since
          the header is customer-facing real estate and staff already
          know to look in the footer. "Customer Dashboard" is the one
          CTA that belongs here.
        */}
        <div className="hidden items-center gap-4 md:flex">
          <Link to={isAuthenticated ? '/dashboard' : '/login'}>
            <Button size="sm">{isAuthenticated ? 'Customer Dashboard' : 'Sign In'}</Button>
          </Link>
        </div>

        <button
          className="md:hidden text-ink"
          aria-label="Open menu"
          aria-expanded={mobileOpen}
          onClick={() => setMobileOpen(true)}
        >
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M4 6h16M4 12h16M4 18h16" strokeLinecap="round" />
          </svg>
        </button>
      </div>

      <MobileNav isOpen={mobileOpen} onClose={() => setMobileOpen(false)} links={NAV_LINKS} />
    </header>
  );
}
